export default function Divider({ color, height }) {
  return (
    <div style={{ height: height, backgroundColor: color, width: "100%" }} />
  );
}
